import { render, staticRenderFns } from "./PickerCard.vue?vue&type=template&id=85ca3a06&"
import script from "./PickerCard.vue?vue&type=script&lang=js&"
export * from "./PickerCard.vue?vue&type=script&lang=js&"
import style0 from "./PickerCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports